"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreAlertCheck = exports.AlertCheckIssue = exports.AlertCheckIssueObjectType = exports.AlertCheckIssueSeverity = void 0;
var cerealParse_1 = require("../cerealParse");
var uuid_1 = require("uuid");
var device_1 = require("./device");
var group_1 = require("./group");
var AlertCheckIssueSeverity;
(function (AlertCheckIssueSeverity) {
    AlertCheckIssueSeverity[AlertCheckIssueSeverity["warning"] = 0] = "warning";
    AlertCheckIssueSeverity[AlertCheckIssueSeverity["error"] = 1] = "error";
})(AlertCheckIssueSeverity || (exports.AlertCheckIssueSeverity = AlertCheckIssueSeverity = {}));
var AlertCheckIssueObjectType;
(function (AlertCheckIssueObjectType) {
    AlertCheckIssueObjectType[AlertCheckIssueObjectType["device"] = 0] = "device";
    AlertCheckIssueObjectType[AlertCheckIssueObjectType["membership"] = 1] = "membership";
    AlertCheckIssueObjectType[AlertCheckIssueObjectType["alertSetting"] = 2] = "alertSetting";
})(AlertCheckIssueObjectType || (exports.AlertCheckIssueObjectType = AlertCheckIssueObjectType = {}));
var AlertCheckIssue = /** @class */ (function () {
    function AlertCheckIssue(id, severity, description, objectType, objectId) {
        this.id = id;
        this.severity = severity;
        this.description = description;
        this.objectType = objectType;
        this.objectId = objectId;
    }
    AlertCheckIssue.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AlertCheckIssue((0, uuid_1.v4)(), cerealParse_1.ParseUtils.getEnum(o, 'severity', AlertCheckIssueSeverity), cerealParse_1.ParseUtils.getString(o, 'description'), cerealParse_1.ParseUtils.getEnum(o, 'objectType', AlertCheckIssueObjectType), cerealParse_1.ParseUtils.getString(o, 'objectId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AlertCheckIssue Model: ".concat(e.message));
        }
    };
    AlertCheckIssue.compare = function (a, b) {
        var compareObjectType = AlertCheckIssueObjectType[a.objectType].localeCompare(AlertCheckIssueObjectType[b.objectType]);
        var compareDescription = a.description.localeCompare(b.description);
        return compareObjectType || compareDescription;
    };
    return AlertCheckIssue;
}());
exports.AlertCheckIssue = AlertCheckIssue;
var PreAlertCheck = /** @class */ (function () {
    function PreAlertCheck(id, devices, memberships) {
        this.id = id;
        this.devices = devices;
        this.memberships = memberships;
    }
    PreAlertCheck.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new PreAlertCheck(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'devices', device_1.MinimalDevice.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'memberships', group_1.MinimalMembership.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid PreAlertCheck Model: ".concat(e.message));
        }
    };
    return PreAlertCheck;
}());
exports.PreAlertCheck = PreAlertCheck;
//# sourceMappingURL=alertCheckIssue.js.map